import { QueryClient } from '@tanstack/react-query';

import { envVars } from '../utils/envVars';

// If you are developing locally offline, and still want the app to work as if you
//  were online, you can temporarily set the FAKE_BEING_ONLINE environment variable
//  to 'true'.
export const fakeBeingOnline = envVars.fakeBeingOnline;

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Make React Query work with Suspense! This basically makes React Query
            //  throw a special kind of pending promise that gets caught by suspense boundaries.
            suspense: true,
            // Make React Query work with error boundaries! This basically makes React Query
            //  throw when it gets an error, instead of returning undefined data and an error object.
            useErrorBoundary: true,
            // There was a weird error where if we didn’t disable retries, then errors throws
            //  in the async code of atomWithQuery atoms did not get caught by the error boundary.
            //  The error would trigger React to unmount the component tree, but it would not
            //  trigger the error boundary. No clue why this happened.
            // In any case, I can’t think of a scenario where retrying a failed query would help,
            //  so it’s fine to disable retries.
            retry: false,
            // We still want failed queries to be retried on remount. While this option is usually
            //  true, setting the previous option to false means we need to set this to true again.
            retryOnMount: true,
            // Set a little 30-second buffer window in which react-query will not refetch even if yo
            //  switch to a different tab or back. This helps deduplicate network requests.
            // See: https://tkdodo.eu/blog/react-query-as-a-state-manager#customize-staletime
            staleTime: 30 * 1000,
            // // Disable refetching on window refocus. It breaks user expectations for data to update
            // //  when you switch away and come back from a different browser tab.
            // refetchOnWindowFocus: false,
            // By default, React Query’s network mode is set to 'online', which means it
            //  pauses making requests when offline until the network comes online.
            // However, we set `networkMode` to 'offlineFirst', to tell React Query to
            //  try making requests the first time when offline, but pause retries until the
            //  network comes back. This way, our query/mutation function runs at least once,
            //  and we can show a toast to the user that the network is offline. Without this,
            //  our app seems broken to users.
            // We allow this behaviour to be overriden when `fakeBeingOnline` is set
            //  to allow developers to work offline and always send requests regardless
            //  of network state.
            networkMode: fakeBeingOnline ? 'always' : 'offlineFirst',
        },
        mutations: {
            // See comment about networkMode above.
            networkMode: fakeBeingOnline ? 'always' : 'offlineFirst',
        },
    },
});
